import { useGet } from '@ngt/opms';
import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';
import { GetImageUploads, GetImageUploadsResponse } from '../api/dtos';

const getData = (response?: SWRResponse<GetImageUploadsResponse, GetImageUploadsResponse>) => response?.data?.data;
const getError = (response?: SWRResponse<GetImageUploadsResponse, GetImageUploadsResponse>) => (response?.error ?? response?.data)?.responseStatus;

export const useGetIMriImageUploads = (
    institutionCode?: string | undefined,
    selectedImagesNotUploaded?: boolean | undefined,
    selectedImagesNotVerified?: boolean | undefined,
    selectedImagesDeidentifiedFailed?: boolean | undefined,
    selectedImagesLegacy?: boolean | undefined,
    configuration?: SWRConfiguration | undefined
) => {
    const request = useMemo(() => {
        return () => {
            return new GetImageUploads({
                institutionCode: institutionCode,
                selectedImagesNotUploaded: selectedImagesNotUploaded,
                selectedImagesNotVerified: selectedImagesNotVerified,
                selectedImagesDeidentifiedFailed: selectedImagesDeidentifiedFailed,
                selectedImagesLegacy: selectedImagesLegacy,
                noCache: Date.now().toString() 
            });
        }
    }, [institutionCode, selectedImagesNotUploaded, selectedImagesNotVerified, selectedImagesDeidentifiedFailed, selectedImagesLegacy]);

    const swrConfigDontReValidate = {
        ...configuration,
        revalidateIfStale: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false
    }

    return useGet(request, { getData, getError }, swrConfigDontReValidate);
}

export default useGetIMriImageUploads;